import React, { FunctionComponent, ReactNode } from 'react';
import { Box, Button, ButtonProps, Collapse, Flex, useDisclosure } from '@chakra-ui/react';
import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons';

type CollapseProps = {
  children: ReactNode;
  toggler: ReactNode;
  togglerProps?: Omit<ButtonProps, 'variant' | 'onClick'>;
  contentWrapperProps?: Omit<ButtonProps, 'variant' | 'onClick'>;
  active?: boolean;
};

const Collapsable: FunctionComponent<CollapseProps> = props => {
  const { children, toggler, togglerProps, contentWrapperProps, active } = props;
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: active });

  return (
    <>
      <Button variant='unstyled' onClick={onToggle} {...togglerProps}>
        <Flex justifyContent='space-between' alignItems='center' gap={4}>
          {toggler}

          {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Flex>
      </Button>

      <Collapse in={isOpen} animateOpacity>
        <Box p='8px 16px' color='white' mt='2' rounded='md' shadow='md' {...contentWrapperProps}>
          {children}
        </Box>
      </Collapse>
    </>
  );
};

export { Collapsable };
